<template>
  <div
    v-if="displayedColors.length > 1"
    :class="[
      bemBlock,
      'base-color-swatches',
      {
        'visually-hidden' : visuallyHidden
      }
    ]"
  >
    <ul
      :class="bemElement('color-container')"
    >
      <li
        v-for="(color, index) in displayedColors"
        v-show="color.displayed"
        :key="index"
        :class="bemElement('item')"
        data-attr="color"
      >
        <button
          type="button"
          :class="[bemElement('swatch', { 'selected': isColorSelected(color) })]"
          :data-color-code="color.code"
          @click="handleSelectColor(color, $event)"
        >
          <span class="visually-hidden">{{ color.text }}</span>
          <span
            :class="bemElement('swatch-display')"
            :style="{'background-color': color.code ? color.code : ''}"
          />
        </button>
      </li>
    </ul>
    <button
      v-if="overflowMaxColors"
      :class="[
        bemElement(expanded ? 'shrink' : 'expand'),
        expanded ? 'btn-minus' : 'btn-plus'
      ]"
      @click="toggleExtended"
    />
  </div>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import EventBusConfig from '../config/eventBusConfig';

const MAX_DISPLAYED_SWATCHES = 3;

export default {
  name: 'BaseColorSwatches',

  mixins: [
    bemClassesMixin,
  ],

  props: {
    visuallyHidden: {
      type: Boolean,
      default: false,
    },
    showCurrent: {
      type: Boolean,
      default: false,
    },
    preExpanded: {
      type: Boolean,
      default: false,
    },
    colors: {
      default: () => [],
      type: Array,
      required: true,
    },
    initialColor: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data: () => ({
    expanded: false,
    selectedColor: '',
    maxDisplayedColors: MAX_DISPLAYED_SWATCHES,
  }),

  computed: {
    overflowMaxColors() {
      return this.colors.length > this.maxDisplayedColors;
    },
    displayedColors() {
      const { colors } = this;
      colors.map((color, index) => {
        const displayedColor = color;
        displayedColor.displayed = this.isColorDisplayed(color, index);
        return displayedColor;
      });
      return colors;
    },
  },

  mounted() {
    this.handleSelectColor(this.initialColor);
    this.expanded = this.preExpanded;
  },

  methods: {
    isColorSelected(color) {
      return this.selectedColor === color.code;
    },
    toggleExtended() {
      this.expanded = !this.expanded;
    },
    handleSelectColor(color, event) {
      if (this.isColorSelected(color)) {
        event.stopPropagation();
      } else {
        this.selectedColor = color.code;
        this.$eventBus.$emit(
          EventBusConfig.events.BaseColorSwatches.colorSelected,
          this.selectedColor,
        );
      }
    },
    isColorDisplayed(color, index) {
      return this.expanded || index < this.maxDisplayedColors || this.isColorSelected(color);
    },
  },
};
</script>
